// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__19mNT","upload":"Small_upload__r0IOX","imageWrap":"Small_imageWrap__3m-Fe","removeBtn":"Small_removeBtn__j3CVx"};